/*
 * Which legal text is on screen.
 *
 * Stored with a sourcing enquiry alongside the consent tick, so what was
 * agreed to can be shown later rather than inferred from "whatever the terms
 * said at some point". Bump this date in the same commit that changes the
 * wording of the Terms of Service, the Privacy Policy or the consent line.
 */
export const TERMS_VERSION = '2026-10-17';

/* The documents themselves, which are English and live on the main site. */
export const TERMS_URL = 'https://aquanetica.com/terms-of-service/';
export const PRIVACY_URL = 'https://aquanetica.com/privacy-policy/';
/* The AI Assistant Terms, linked from the notice under the chat box. */
export const AI_TERMS_URL = 'https://aquanetica.com/ai-assistant-terms/';
